export const CHANGE_COMPARISON_PRODUCTS = 'CHANGE_COMPARISON_PRODUCTS';

export const amountOfProducts = count => dispatch => {
    return dispatch({
        type: CHANGE_COMPARISON_PRODUCTS,
        payload: {
            count: count,
        },
    });
};
